export default "__VITE_ASSET__CCMuFb$V__"